







































import Vue, { PropType } from 'vue';

import Icon from '@/components/common/icon.vue';
import InfoComponent from '@/components/common/info-component.vue';
import { ModalInfoIcon } from '@/interfaces/props/ModalInfo';
import i18n from '@/plugins/i18n/i18n';
import { eventBus } from '@/services/event-bus';

export default Vue.extend({
	name: 'ModalInfo',
	props: {
		icon: {
			type: Object as PropType<ModalInfoIcon>,
			required: false,
			default: () => {
				return {
					show: false,
					class: '',
					paths: 1
				};
			}
		},
		bemInfo: {
			type: Object,
			default: () => {}
		},
		innerDesc: {
			type: Object,
			default: () => {}
		},
		title: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		actions: {
			type: Boolean,
			default: true
		},
		btnSubmit: {
			type: Boolean,
			default: true
		},
		btnCancel: {
			type: Boolean,
			default: false
		},
		btnSubmitTxt: {
			type: String,
			default: ''
		},
		btnCancelTxt: {
			type: String,
			default: i18n.t('message.common.modal.modalCancel')
		}
	},
	methods: {
		getModalRef(): string {
			return this.$parent.$vnode.data?.ref?.toLowerCase();
		},
		clickBtnSubmit(event: any): void {
			event.modalRef = this.getModalRef();
			eventBus.$emit('modal-submit', event);
		},
		clickBtnCancel(): void {
			eventBus.$emit('modal-cancel');
		}
	},
	components: { InfoComponent, Icon }
});
